import { Divider, Segmented, Typography } from 'antd';
import type { FC } from 'react';

const { Title } = Typography;

interface ApiSelectorProps {
    provider: string;
    setProvider: (value: string) => void;
    minimaxMode: string;
    setMinimaxMode: (value: string) => void;
}

const ApiSelector: FC<ApiSelectorProps> = ({
    provider,
    setProvider,
    minimaxMode,
    setMinimaxMode,
}) => {
    return (
        <>
            <Title level={5}>Chọn AI</Title>

            <Segmented
                block
                value={provider}
                onChange={(value) => setProvider(value as string)}
                options={[
                    { label: 'Hailuo AI', value: 'minimax' },
                    {
                        label: 'Runway AI (Tạm tắt)',
                        value: 'runway',
                        disabled: true,
                    },
                ]}
                className="w-full p-1"
            />

            {provider === 'minimax' && (
                <>
                    <Title level={5} className="mt-3">
                        Chọn loại
                    </Title>
                    <Segmented
                        block
                        value={minimaxMode}
                        onChange={(value) => setMinimaxMode(value as string)}
                        options={[
                            { label: 'Image to Video', value: 'image' },
                            {
                                label: 'Text to Video',
                                value: 'text',
                            },
                        ]}
                        className="w-full p-1"
                    />
                </>
            )}

            <Divider />
        </>
    );
};

export default ApiSelector;
